export default "__VITE_ASSET__B901Sixq__"